/*
 * @Author: xuyangt
 * @Description: 
 * @Date: 2023-06-05 15:30:28
 * @LastEditTime: 2025-02-07 17:10:41
 */
/**
 * Created by wangshhj on 2018/1/11.
 */

/**
 * @namespace Search
 */
import NCCreateSearch from './createSearch';
import NCCreateSimpleSearch from './createSimpleSearch';
import {
    setSearchValue,
    setSearchValByField,
    getAllSearchData,
    getSearchValByField,
    setDisabledByField,
    closeSearchPlanArea,
    openAdvSearch,
    saveSearchSchema,
    addSearchSchema,
    setDisabled,
    clearSearchArea,
    getQueryInfo,
    getOprtypeByField,
    changeItemVisibleByField,
    setRequiredByField,
    setTemlateByField,
    getSearchSnap,
    setSearchSnap,
    setRemovedByField,
    setSearchStatus,
    addEventListener,
    removeEventListener,
    executeSearch,
    getUserQueryHistory,
    pageQuery,
    clearUserQueryHistory,
    getCurrentSearchAreaId,
    getLastSearchCondition,
    queryExtraSearch,
    getSearchStatus,
    getQuerySchemeList,
    setQueryScheme
} from './methods';
let search = {
    NCCreateSearch,
    NCCreateSimpleSearch,
    setSearchValue,
    setSearchValByField,
    getAllSearchData,
    getSearchValByField,
    setDisabledByField,
    closeSearchPlanArea,
    openAdvSearch,
    saveSearchSchema,
    addSearchSchema,
    setDisabled,
    clearSearchArea,
    getQueryInfo,
    getOprtypeByField,
    changeItemVisibleByField,
    setRequiredByField,
    setTemlateByField,
    getSearchSnap,
    setSearchSnap,
    setRemovedByField,
    setSearchStatus,
    addEventListener,
    removeEventListener,
    executeSearch,
    getUserQueryHistory,
    pageQuery,
    clearUserQueryHistory,
    getCurrentSearchAreaId,
    getLastSearchCondition,
    queryExtraSearch,
    getSearchStatus,
    getQuerySchemeList,
    setQueryScheme
};

export default search;
